module.exports = __webpack_public_path__ + "assets/img/block-d9b48a56.png";